import _createForOfIteratorHelper from "/opt/github/_work/frontend-website-cms/frontend-website-cms/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import $ from "cash-dom";

function detectEdge() {
  var ua = window.navigator.userAgent;
  var edge = ua.indexOf("Edge/");

  if (edge > 0) {
    return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
  }

  return false;
}

export default function () {
  if (detectEdge()) {
    var sparklines = $(".card__chart > img");
    $(sparklines).css("display", "none");

    var _iterator = _createForOfIteratorHelper(sparklines),
        _step;

    try {
      var _loop = function _loop() {
        var image = _step.value;
        var canvasEl = $("<canvas></canvas>").appendTo($(image).parent());
        var canvas = $(canvasEl)[0];
        var ctx = canvas.getContext("2d");
        var img = new Image();

        img.onload = function () {
          canvas.height = canvas.width * (img.height / img.width);
          var oc = document.createElement("canvas");
          var octx = oc.getContext("2d");
          oc.width = img.width * 0.5;
          oc.height = img.height * 0.5;
          octx.drawImage(img, 0, 0, oc.width, oc.height);
          octx.drawImage(oc, 0, 0, oc.width * 0.5, oc.height * 0.5);
          ctx.drawImage(oc, 0, 0, oc.width * 0.5, oc.height * 0.5, 0, 0, canvas.width, canvas.height);
        };

        img.src = "".concat(location.origin).concat($(image).attr("data-src"));
        $(canvasEl).css("width", "100%");
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}